import { render, staticRenderFns } from "./GetStartedForm.vue?vue&type=template&id=44340088&scoped=true&"
import script from "./GetStartedForm.vue?vue&type=script&lang=js&"
export * from "./GetStartedForm.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedForm.vue?vue&type=style&index=0&id=44340088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44340088",
  null
  
)

export default component.exports